import React, { FormEvent, useEffect } from 'react';
import cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import Input from 'src/Components/Form/Input';
import Button from 'src/Components/Form/Button';
import useInput from 'src/hooks/useInput';
import { useLogin } from 'src/hooks/queries/login';
import { requiredValidation } from 'src/utils/validations';
import LoginWrapper from './styles';

const Login: React.FC = () => {
	const { bind: bindUsernameInput, value: username } = useInput({
		validations: requiredValidation,
	});
	const { bind: bindPasswordInput, value: password } = useInput();
	const {
		mutate: login,
		isLoading: loginIsLoading,
		isError: loginIsError,
		error: loginError,
		data: loginData,
	} = useLogin();
	const { push } = useHistory();

	useEffect(() => {
		if ((loginData as any)?.data.account) {
			push('/');
		}
	}, [loginData]);

	const handleLogin = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		login({
			username,
			password,
		});
	};

	const handleShowCookies = () => {
		const JWT = cookies.get('jwt');
		// eslint-disable-next-line no-alert
		alert(JWT);
	};

	return (
		<LoginWrapper>
			<div id='login-wrapper'>
				<h3 className='title'>ورود به پول‌من</h3>
				<form id='login-form' onSubmit={handleLogin}>
					<Input
						type='text'
						id='username'
						label='نام کاربری'
						customErrorMessage={
							loginIsError &&
							loginError?.response?.data?.status === 'fail' &&
							loginError?.response?.data?.message
						}
						{...bindUsernameInput}
					/>
					<Input
						type='password'
						id='password'
						label='رمزعبور'
						customErrorMessage={
							loginIsError &&
							loginError?.response?.data?.status === 'fail' &&
							loginError?.response?.data?.message
						}
						{...bindPasswordInput}
					/>
					<Button
						loading={loginIsLoading}
						type='submit'
						id='login-button'
					>
						ورود
					</Button>
					<button
						type='button'
						id='show-cookies'
						onClick={handleShowCookies}
					>
						*
					</button>
				</form>
			</div>
		</LoginWrapper>
	);
};

export default Login;
